
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 2v20h16.005V12H20V6.347L15.556 2H4zm11.556 1.525l2.918 2.822h-2.918V3.525zM8 10h8V8.998H8V10zm0 2h8v-1H8v1zm0 2h8v-1H8v1zm0 2h8v-1H8v1zm0 1.999h8v-1H8v1z","fill-rule":"evenodd"}})])
          )
        }
      }
    